import { useState } from "react";
import { LocateFixed, Loader2 } from "lucide-react";
import CityAutocomplete from "@/components/CityAutocomplete";
import { toast } from "sonner";

const RADII = [5, 10, 25, 50];

export default function AroundMeBar({ setUserLoc, radius, setRadius }) {
  const [city, setCity] = useState("");
  const [loading, setLoading] = useState(false);

  const locateGps = () => {
    if (!navigator.geolocation) return toast.error("Géolocalisation non disponible");
    setLoading(true);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setUserLoc({ lat: pos.coords.latitude, lng: pos.coords.longitude });
        setLoading(false);
        toast.success("Position détectée (jamais stockée)");
      },
      () => {
        setLoading(false);
        toast.error("Impossible d'obtenir la position");
      },
      { enableHighAccuracy: true, timeout: 8000 }
    );
  };

  const onSelect = (item) => {
    setUserLoc({ lat: item.lat, lng: item.lng });
    toast.success(`Centré sur ${item.label}`);
  };

  return (
    <div className="flex items-center gap-1.5 w-full">
      <button data-testid="around-me-btn" onClick={locateGps} title="Autour de moi (GPS)"
        className="h-9 shrink-0 px-2.5 sm:px-3 rounded-lg bg-sky-600 hover:bg-sky-500 active:scale-95 transition text-white font-bold text-xs flex items-center justify-center gap-1.5">
        {loading ? <Loader2 size={16} className="animate-spin" /> : <LocateFixed size={16} />}
        <span className="hidden md:inline">Autour de moi</span>
      </button>
      <CityAutocomplete testid="city-search" value={city} onChange={setCity} onSelect={onSelect}
        placeholder="Saisir une ville (ex. Nîmes)" />
      <select data-testid="radius-select" value={radius} onChange={(e) => setRadius(Number(e.target.value))}
        aria-label="Rayon de recherche"
        className="h-9 px-1.5 rounded-lg bg-[#0B0F17] border border-slate-700 text-xs text-slate-100 focus:outline-none focus:border-sky-500 shrink-0">
        {RADII.map((r) => <option key={r} value={r}>{r} km</option>)}
      </select>
    </div>
  );
}
